
export default {
    name: "OffersAnimationSection",
    props: {
        offersAnimation: {
            type: Object,
            default: undefined
        }
    },
    computed: {
        showOffersAnimationSection() {
            return this.offersAnimation
                && this.offersAnimation.selectionsTileList
                && this.offersAnimation.selectionsTileList.length > 0;
        }
    }
}
